/* ipl-minicart.js
   Add to basket on the IPL product page -> AJAX add + open the Warehouse mini-cart drawer.

   The section (sections/ipl-product-page.liquid) submits a plain form to /cart/add with
   return_to=/cart, so every add threw the buyer onto the cart page. ipl-pdp-a11y.js then
   added a second, competing capture-phase handler that showed an inline "Added" note but
   never opened the drawer. This file replaces both behaviours for #iplpAtc / #iplpBarAtc:

     1. POST /cart/add.js with the selected variant + quantity
     2. GET /cart.js for the fresh item count
     3. dispatch the theme's own `product:added` event (Warehouse's MiniCart listens for it,
        re-renders sections/mini-cart and opens the drawer) and update the header count
     4. safety net: if the drawer is still closed a moment later, click the header cart
        toggle; if there is no drawer on the page at all, go to /cart

   It MUST be loaded before ipl-pdp-a11y.js (both are deferred, so document order decides):
   its capture listener is registered first and stops the event, so neither the a11y
   interceptor nor the section's own submit handler run for the same click.
   "Buy it now" (#iplpBuyNow) is untouched and still goes straight to checkout.
*/
(function () {
  'use strict';

  var root = document.getElementById('iplp');
  if (!root) return;

  var CFG = window.IPLPDP || {};
  var ROUTES = window.routes || {};
  var ADD_URL = root.getAttribute('data-cart-add-url') || CFG.cartAddUrl || ROUTES.cartAddUrl || '/cart/add';
  var CART_URL = root.getAttribute('data-cart-url') || CFG.cartUrl || ROUTES.cartUrl || '/cart';

  /* ---------- variants: read the same JSON the section inlined ---------- */
  var VARIANTS = null;
  function loadVariants() {
    if (VARIANTS) return VARIANTS;
    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i++) {
      var t = scripts[i].textContent || '';
      var at = t.indexOf('var VARIANTS = ');
      if (at < 0) continue;
      var m = t.slice(at).match(/^var VARIANTS = (\[[\s\S]*?\]);\s*\n\s*var MONEY_FORMAT/);
      if (!m) continue;
      try { VARIANTS = JSON.parse(m[1]); } catch (e) { VARIANTS = null; }
      if (VARIANTS && VARIANTS.length) return VARIANTS;
    }
    return VARIANTS;
  }

  function selectedOptions() {
    var opts = [];
    var blocks = root.querySelectorAll('.iplp__opt');
    for (var i = 0; i < blocks.length; i++) {
      var sel = blocks[i].querySelector('[data-optselect]');
      if (sel) { opts.push(sel.value); continue; }
      var act = blocks[i].querySelector('[data-optpill].active');
      opts.push(act ? act.getAttribute('data-value') : null);
    }
    return opts;
  }

  function currentVariant() {
    var list = loadVariants();
    if (!list) return null;
    var opts = selectedOptions();
    if (!opts.length) return list[0] || null;          /* single default variant */
    for (var i = 0; i < list.length; i++) {
      var v = list[i], ok = true;
      for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }

  /* ---------- small helpers ---------- */
  function qty() {
    var q = document.getElementById('iplpQty');
    return Math.max(1, parseInt(q && q.value, 10) || 1);
  }

  function buttons() {
    return [document.getElementById('iplpAtc'), document.getElementById('iplpBarAtc')].filter(Boolean);
  }

  function setButtons(disabled, text) {
    buttons().forEach(function (b) { b.disabled = disabled; if (text) b.textContent = text; });
  }

  function showMsg(text) {
    var msg = document.getElementById('iplpMsg');
    if (!msg) return;
    msg.textContent = text || '';
    msg.style.display = text ? 'block' : 'none';
  }

  function setCartCount(n) {
    var els = document.querySelectorAll('.header__cart-count');
    for (var i = 0; i < els.length; i++) els[i].textContent = n;
    if (window.theme) window.theme.cartCount = n;
  }

  function postForm(id, q, returnTo) {
    var f = document.createElement('form');
    f.method = 'post';
    f.action = ADD_URL;
    [['id', id], ['quantity', q], ['return_to', returnTo]].forEach(function (p) {
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = p[0]; i.value = p[1];
      f.appendChild(i);
    });
    document.body.appendChild(f);
    f.submit();
  }

  function miniCartIsOpen() {
    var mini = document.getElementById('mini-cart');
    if (!mini) return false;
    return mini.getAttribute('aria-hidden') !== 'true';
  }

  function openMiniCart(variant, q, cart) {
    /* Warehouse adds event.detail.quantity to its own counter, so pre-set it to the
       pre-add value; the authoritative /cart.js figure is written right after */
    if (window.theme) window.theme.cartCount = Math.max(0, cart.item_count - q);
    document.documentElement.dispatchEvent(new CustomEvent('product:added', {
      bubbles: true,
      detail: { variant: variant, quantity: q, cart: cart }
    }));
    setCartCount(cart.item_count);

    setTimeout(function () {
      if (miniCartIsOpen()) return;
      var mini = document.getElementById('mini-cart');
      if (!mini) { window.location.href = CART_URL; return; }
      /* the theme did not open it: ask it to re-render, then use its own toggle */
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      var toggle = document.querySelector('.header__cart-toggle[data-action="toggle-mini-cart"], [aria-controls="mini-cart"]');
      if (toggle) toggle.click();
      setTimeout(function () {
        /* still nothing (theme.js failed to load?) -> show the cart page */
        if (!miniCartIsOpen()) window.location.href = CART_URL;
      }, 1200);
    }, 700);
  }

  /* ---------- the add ---------- */
  function addToBasket(variant) {
    var q = qty();
    showMsg('');
    setButtons(true, 'Adding...');
    var restore = function () { setButtons(false, 'Add to basket'); };
    var fallback = function () { postForm(variant.id, q, CART_URL); };
    if (!window.fetch || !window.Promise) { fallback(); return; }

    fetch(ADD_URL + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(variant.id), quantity: q }] })
    }).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; },
                           function () { return { ok: r.ok, status: r.status, data: null }; });
    }).then(function (res) {
      if (!res.ok) {
        /* 422: Shopify refused (stock limit, unavailable) — show its reason, do not redirect */
        if (res.status === 422 && res.data && (res.data.description || res.data.message)) {
          restore();
          showMsg(res.data.description || res.data.message);
          return;
        }
        throw new Error('add failed ' + res.status);
      }
      return fetch(CART_URL + '.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          restore();
          openMiniCart(variant, q, cart);
        });
    }).catch(function () {
      fallback();
    });
  }

  function onClick(e) {
    var btn = e.target && e.target.closest && e.target.closest('#iplpAtc, #iplpBarAtc');
    if (!btn) return;
    if (btn.disabled) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    var variant = currentVariant();
    /* no variant found: leave the click to the section's own handler */
    if (!variant) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!variant.available) { showMsg('This option is sold out.'); return; }
    addToBasket(variant);
  }

  document.addEventListener('click', onClick, true);

  /* back-button / bfcache: never leave a button stuck on "Adding..." */
  window.addEventListener('pageshow', function () {
    buttons().forEach(function (b) { if (b.textContent.trim() === 'Adding...') { b.disabled = false; b.textContent = 'Add to basket'; } });
  });
})();
